import { render } from "./AddRoadmap.vue?vue&type=template&id=35ea76ff"
import script from "./AddRoadmap.vue?vue&type=script&lang=ts"
export * from "./AddRoadmap.vue?vue&type=script&lang=ts"
script.render = render

export default script